import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    selectContainer: {
      width: '10em',
      marginRight: '4em',
    },

    dropdownContainer: {
      position: 'relative',
      width: '7em',
      left: 0,
      zIndex: 1.1,
      minWidth: '100%',
      backgroundColor: '#ffffff',
      borderRadius: '5px',
      border: '2px solid #1b9ce5',
      boxShadow: '0 0 8px #00000f',
      justifyContent: 'left',
    },
    option: {
      padding: '0.5em',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#a3d7f4',
      },
    },
  },
  {
    name: 'Dropdown',
  },
);
